import React from 'react';
import About from '../components/About';

export default class AboutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return ( 
      <div>
        <About/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/About.js